import {ReloadOutlined} from '@ant-design/icons';
import {Input, Switch, Tooltip} from "antd";
import React from "react";
import IconTriggerModal from "../../Snippets/IconTriggerModal";

/**
 * Repetição do passo. É um ajuste opcional, não o conteúdo principal da ação —
 * por isso fica colapsado numa única linha (título + interruptor) e só expande
 * os campos quando ativado. Antes ocupava um card inteiro mesmo desligado.
 */
export const LoopActionInput = ({value, onChange, onBlur, fieldName, fieldLabel}) => {

    const isActive = !!(value && value.active);

    const onValueChange = (valueChange, field) => {
        onChange({
            ...value,
            [field]: valueChange,
        })
    }

    const onChangeActive = (valueChange) => {
        onChange({
            active: valueChange,
            maxLoop: null,
            valueReference: null
        })
    }

    return (
        <div className={`ae-loop ${isActive ? "ae-loop--on" : ""}`}>
            <div className="ae-loop__head">
                <ReloadOutlined className="ae-loop__icon"/>
                <span className="ae-loop__title">Repetir este passo</span>
                <Tooltip title="Executa a ação uma vez para cada item de uma lista do fluxo">
                    <Switch
                        size="small"
                        checked={isActive}
                        onChange={onChangeActive}
                    />
                </Tooltip>
            </div>
            {isActive && (
                <div className="ae-loop__body">
                    <div className="ae-field">
                        <label className="ae-label">Valor de referência</label>
                        <Input
                            onBlur={onBlur}
                            value={value && value.valueReference ? value.valueReference : null}
                            onChange={(valueChange) => onValueChange(valueChange.target.value, 'valueReference')}
                            placeholder="Lista que será percorrida"
                            addonAfter={<IconTriggerModal fieldName={`${fieldName}.valueReference`}
                                                          fieldLabel="Valor de Referência"
                                                          isCode
                                                          acceptEntryLoop={false}
                                                          // O laço percorre a lista do campo: a
                                                          // anotação entra inteira, sem o caminho
                                                          // até um item.
                                                          wholeField
                            />}
                        />
                    </div>
                    <div className="ae-field">
                        <label className="ae-label">Máximo de repetições</label>
                        <Input
                            onBlur={onBlur}
                            value={value && value.maxLoop ? value.maxLoop : null}
                            onChange={(valueChange) => onValueChange(valueChange.target.value, 'maxLoop')}
                            placeholder="Limite de execuções do laço"
                            addonAfter={<IconTriggerModal fieldName={`${fieldName}.maxLoop`}
                                                          fieldLabel="Máximo de repetições do laço"
                                                          acceptEntryLoop={false}
                            />
                        }
                        />
                    </div>
                </div>
            )}
        </div>
    )
}
